module.exports = __webpack_public_path__ + "static/6-61db59089da1ab56cc3845f926ef8bb5.jpg";